
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-213402b0&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReleaseProtocol.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReleaseProtocol.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-213402b0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReleaseProtocol.vue"),
  /* scopeId */
  "data-v-213402b0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/components/ReleaseProtocol.vue
// module id = 1012
// module chunks = 0